import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateAuth } from '../features/featuresSlice';
import { adminLogin } from '../api/api';

const LoginForm = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await adminLogin({ email, password });
            
            if (response.status) {
                dispatch(updateAuth(true));
                navigate('/dashboard');
            } else {
                setError(response.message);
            }
        } catch (err) {
            setError('An unexpected error occurred');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full max-w-md">
            <div className="mb-8">
                <h2 className="text-3xl font-bold mb-2 text-gray-900">
                    Welcome back to DingAI
                </h2>
                <p className="text-gray-500 mt-4">Log in to your account to continue</p>
            </div>

            {error && (
                <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">
                    {error}
                </div>
            )}

            <form className="space-y-6" onSubmit={handleSubmit}>
                <div className="w-full">
                    <div className="mb-1 h-[72px]">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                            Email address
                        </label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full h-[48px] px-3 py-2 border border-gray-300 rounded-xl focus:ring-1 focus:ring-[#2962FF] focus:border-[#2962FF] outline-none"
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                </div>

                <div className="w-full">
                    <div className="mb-1 h-[72px]">
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                            Password
                        </label>
                        <div className="relative w-full">
                            <input
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full h-[48px] px-3 py-2 pr-10 border border-gray-300 rounded-xl focus:ring-1 focus:ring-[#2962FF] focus:border-[#2962FF] outline-none"
                                placeholder="Enter your password"
                                required
                            />
                            <button
                                type="button"
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                        </div>
                    </div>
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full h-[48px] py-3 bg-[#2962FF] text-white font-medium rounded-xl transition-colors duration-200 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loading ? 'Logging in...' : 'Log in'}
                </button>
            </form>
        </div>
    );
};

export default LoginForm;
